import {Component, HostBinding} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {FuseConfigService} from '../../../../../@fuse/services/config.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {FuseConfig} from '../../../../../@fuse/types';
import {select, Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {isDashboardViewFullScreenState} from '@app/components/projects/surveys/results/dashboard/widgets/store/dashboard-widget.seletors';

@Component({
  selector: 'app-hide-top-bar',
  imports: [CommonModule, MatIconModule],
  templateUrl: './hide-top-bar.component.html',
  standalone: true,
  styleUrls: ['./hide-top-bar.component.scss']
})
export class HideTopBarComponent extends OnDestroyMixin {

  fuseConfig: any;

  barDisplayed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  displayNavBar = true;

  top40 = '40px';

  @HostBinding('style.top') cssTop = this.top40;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private store: Store<AppState>
  ) {
    super();

    // Écouter l'état displayNavBar du layout
    this.store
      .pipe(
        untilComponentDestroyed(this),
        select(isDashboardViewFullScreenState),
      )
      .subscribe((data) => {
        this.displayNavBar = !data;

        // Si displayNavBar est false, forcer la toolbar à être cachée
        if (!this.displayNavBar) {
          this._fuseConfigService.setConfig({
            layout: {
              toolbar: {
                hidden: true,
              },
            }
          }, {emitEvent: true});
        }
      });

    if (localStorage.getItem('topbarDisplayed')) {
      this.barDisplayed$.next(localStorage.getItem('topbarDisplayed') === 'true');
    }

    this.barDisplayed$.pipe(
      untilComponentDestroyed(this),
    ).subscribe((display) => {
      if (display && this.displayNavBar) {
        this.cssTop = this.top40;

        // Restaurer l'état de pliage sauvegardé par l'utilisateur

        this._fuseConfigService.setConfig({
          layout: {
            toolbar: {
              hidden: false,
            },
          }
        }, {emitEvent: true});
      } else {
        this.cssTop = '0';
        this._fuseConfigService.setConfig({
          layout: {
            toolbar: {
              hidden: true,
            },
          }
        }, {emitEvent: true});
      }
      // console.log('[topBarFlow][3]!!!!!!!!!!!! Write to localStorage', display);
      localStorage.setItem('topbarDisplayed', `${display}`);

    });

    this._fuseConfigService.config
      .pipe(untilComponentDestroyed(this))
      .subscribe((settings) => {
        if (this.barDisplayed$.value !== !settings.layout.toolbar.hidden) {
          this.barDisplayed$.next(!settings.layout.toolbar.hidden);
        }
      });

  }

  switchTopBar() {
    // Ne permettre le changement que si displayNavBar est true
    if (this.displayNavBar) {
      this.barDisplayed$.next(!this.barDisplayed$.value);
    }
  }
}
